jQuery(function($) {
  /*
  $('a[href^="#"]').click(function(event) {
    event.preventDefault();
    $('html,body').animate({scrollTop: $(this.hash).offset().top}, 500);
  });
  */

  $('.expand-all').click(function() {
    $(this).parent().parent('section').find('input[type="checkbox"]').prop('checked', true);
  });
  $('.collapse-all').click(function() {
    $(this).parent().parent('section').find('input[type="checkbox"]').prop('checked', false);
  });

  $('.accordions input[type="checkbox"]').change(function() {
    if ($(this).prop('checked') === true) {
      $(this).next('.accordion-outer').find('input').removeAttr('tabindex');
      $(this).next('.accordion-outer').find('label').attr('tabindex', '0');
    }
    else {
      $(this).next('.accordion-outer').find('input').attr('tabindex', '-1');
      $(this).next('.accordion-outer').find('label').attr('tabindex', '-1');
    }
  });

  $('#JS-toggle-nav').click(function() {
    $(this).toggleClass('nav-toggle-open');
    if ($(this).hasClass('nav-toggle-open')) {
      $(this).text('CLOSE');
    }
    else {
      $(this).text('MENU');
    }
  });

  $('.js-expand-text').click(function() {
    const text_to_expand = $(this).parent();
    text_to_expand.toggleClass('expanded');
    $(this).toggleClass('expanded');
    if ($(this).hasClass('expanded')) {
      $(this).text('VIEW LESS');
    }
    else {
      $(this).text('VIEW MORE');
    }
  });

  $('.js-floating-accordion').click(function() {
    $(this).next('ul').slideToggle(200);
    $(this).toggleClass('closed');
  });


  // Date field logic
  const $start_date = $('input[name="start"]');
  const $end_date = $('input[name="end"]');

  // Check start date against end date, if start date is after end date update enddate min value
  $start_date.change(function() {
    $end_date.attr('min', $start_date.val());

    // Clear end date value is less then the start date, clear field
    if ($end_date.val() < $start_date.val()) {
      $end_date.val('');
    }
  });

  // Check end date against start date, if end date is before start date update startdate max value
  $end_date.change(function() {
    $start_date.attr('max', $end_date.val());
    // Clear start date value is greater then the end date, clear field
    if ($start_date.val() > $end_date.val()) {
      $start_date.val('');
    }
  });
  $('details').on('focusout', function(event) {
    // Delay the check to ensure that focus has actually moved out
    setTimeout(() => {
      if (!$(this).find(':focus').length) {
        // Close the <details> element if nothing inside it is focused
        $(this).prop('open', false);
      }
    }, 0);
  });
});
